module.exports = __webpack_public_path__ + "img/kairat.ce281961.png";